import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Link,
  Divider,
  useTheme,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import {
  Home,
  ShoppingBag,
  Info,
  Support,
  Gavel,
  Business,
} from '@mui/icons-material';

const SitemapPage = () => {
  const theme = useTheme();

  const sitemapSections = [
    {
      title: 'Main Pages',
      icon: <Home />,
      links: [
        { label: 'Home', href: '/' },
        { label: 'Products', href: '/products' },
        { label: 'About Us', href: '/about' },
        { label: 'Our Story', href: '/our-story' },
        { label: 'Contact Us', href: '/contact' },
      ],
    },
    {
      title: 'Products',
      icon: <ShoppingBag />,
      links: [
        { label: 'All Products', href: '/products' },
        { label: 'Marble', href: '/products?category=marble' },
        { label: 'Granite', href: '/products?category=granite' },
        { label: 'Tiles', href: '/products?category=tiles' },
        { label: 'Natural Stone', href: '/products?category=natural-stone' },
        { label: 'Featured Products', href: '/products?featured=true' },
      ],
    },
    {
      title: 'Company',
      icon: <Business />,
      links: [
        { label: 'About Us', href: '/about' },
        { label: 'Our Story', href: '/our-story' },
        { label: 'Careers', href: '/careers' },
        { label: 'Become a Seller', href: '/register?type=seller' },
      ],
    },
    {
      title: 'Support',
      icon: <Support />,
      links: [
        // { label: 'Help Center', href: '/help' },
        { label: 'Contact Us', href: '/contact' },
        { label: 'Shipping Info', href: '/shipping' },
        { label: 'Returns & Refunds', href: '/ReturnRefund' },
        { label: 'Track Your Order', href: '/track-order' },
      ],
    },
    {
      title: 'Legal',
      icon: <Gavel />,
      links: [
        { label: 'Privacy Policy', href: '/privacy' },
        { label: 'Terms of Service', href: '/terms' },
        { label: 'Cookie Policy', href: '/cookies' },
        { label: 'Seller Agreement', href: '/seller-terms' },
        { label: 'Compliance', href: '/compliance' },
      ],
    },
    {
      title: 'Services',
      icon: <Info />,
      links: [
        // { label: 'Bulk Orders', href: '/bulk-orders' },
        // { label: 'Custom Solutions', href: '/CustomSol' },
        // { label: 'Installation Services', href: '/installation' },
        { label: 'Quality Assurance', href: '/Quality' },
      ],
    },
  ];

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', py: 6 }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 700,
              mb: 2,
              background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Sitemap
          </Typography>
          <Typography variant="h6" color="text.secondary">
            Find all pages and sections of our website
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {sitemapSections.map((section, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: '100%',
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: theme.shadows[8],
                  },
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      mb: 2,
                      color: theme.palette.primary.main,
                    }}
                  >
                    {section.icon}
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      {section.title}
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 2 }} />
                  <List dense>
                    {section.links.map((link, linkIndex) => (
                      <ListItem
                        key={linkIndex}
                        sx={{
                          px: 0,
                          '&:hover': {
                            bgcolor: 'action.hover',
                            borderRadius: 1,
                          },
                        }}
                      >
                        <ListItemText
                          primary={
                            <Link
                              component={RouterLink}
                              to={link.href}
                              sx={{
                                color: 'text.primary',
                                textDecoration: 'none',
                                '&:hover': {
                                  color: 'primary.main',
                                  textDecoration: 'underline',
                                },
                              }}
                            >
                              {link.label}
                            </Link>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ mt: 6, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Can't find what you're looking for?{' '}
            <Link
              component={RouterLink}
              to="/contact"
              sx={{
                color: 'primary.main',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              Contact Us
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default SitemapPage;

